import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useFormatMessage } from '@acre/utils'
import { Switch, SwitchVariant } from '@acre/design-system'

import CaseInfo from './Info/CaseInfo'
import VersionNavigation from './VersionNavigation'

const ReviewModeDrawer = () => {
  const navigate = useNavigate()
  const formatMessage = useFormatMessage()
  const location = useLocation()

  const { caseId, version } = useParams<{ caseId: string; version?: string }>()

  const [reviewModeOn, setReviewModeOn] = useState(false)

  useEffect(() => {
    if (!location.pathname.includes(`cases/${caseId}/review-mode/version`)) {
      setReviewModeOn(false)
    }
  }, [caseId, location.pathname])

  return (
    <>
      <CaseInfo />
      <Switch
        variant={SwitchVariant.Large}
        id="ToggleReviewMode"
        checked={reviewModeOn}
        disabled={false}
        onChange={() => {
          setReviewModeOn(!reviewModeOn)
          if (reviewModeOn) {
            navigate(`/cases/${caseId}/overview`)
          } else navigate(`/cases/${caseId}/review-mode/version/${version || 1}/fact-find`)
        }}
        label={formatMessage(`cases.reviewMode.${reviewModeOn ? `reviewModeOn` : `reviewModeOff`}`)}
      />
      <VersionNavigation caseId={caseId!} disabled={!reviewModeOn} />
    </>
  )
}

export default ReviewModeDrawer
